/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-01 17:29:10
 * @Last Modified by: Josselin Hubert
 * @Last Modified time: 2020-09-11 01:09:55
 */


export default {
  appName: 'Premium Development',

  button: {
    cancel: 'Cancel',
    clear: 'Clear',
    close: 'Close',
    confirm: 'Confirm',
    contactUs: 'Contact us',
    delete: 'Delete',
    knowMore: 'Find out more',
    next: 'Next',
    ok: 'Ok',
    previous: 'Previous',
    new: 'New',
    no: 'No',
    save: 'Save',
    sendMessage: 'Send Message',
    validate: 'Validate',
    yes: 'Yes'
  },

  dialog: {
    sendingEmail: 'Sending email...',
  },

  enum: {
    no: 'No',
    yes: 'Yes',
    dark: 'Dark',
    light: 'Light'
  },

  error: {
    between: '{field} must be between {min} and {max} chars',
    format: 'Invalid format',
    maxLength: '{field} must be less than {lenght} chars length',
    minLength: '{field} must be at least {lenght} chars length',
    required: '{field} is required',
    unique: 'Field must be unique',
    email: {
      required: 'Email is required',
      email: 'Unvalid email format'
    },
    password: {
      match: "Passwords doesn't match"
    },
  },

  field: {
    email: 'Email',
    enterYourPassword: 'Entrer your password',
    firstName: 'First name',
    fullName: 'Full name',
    lastName: 'Last name',
    login: 'Login',
    message: 'Message',
    password: 'Password',
    required: 'Required',
    retypeYourPassword: 'Retype your password',
    title: 'Title',
  },

  header: {
    answer: 'Answer',
    category: 'Category',
    question: 'Question',
    country: 'Country',
    capital: 'Capital',
    flag: 'Flag',
  },

  hint: {

  },

  navigation: {
    home: 'Home',
    about: 'About',
    contactUs: 'Contact Us',
    skills: 'Skills',
  },

  panel: {
    home: {
      subtitle1: "For consulting or development, we have a team of professionals who adapt to your needs.",
      subtitle2: "With over 15 years of experience in software development, we design and build the solutions that suit you.",

      content: {
        title: 'Our skills',
        description: "With our expertise, you are guaranteed to work with the best developers.",
        featConseil: "Consulting : Project orientation, technical advice, methodology, software workshops, acceptance, training...",
        featDb: "Database : Modeling, audit, restructuring..",
        featSoftware: "Software : From scratch development, audit, bug fixes, design, ergonomics, addition of new features...",
      },

      contact: {
        title: 'Contact us',
        message: "Send us a message for more informations, an advice, a quotation. We will respond as soon as possible.",
      },
    },

    skills: {
      title: 'Skills',
      subtitle1: "Our main activity domain is C# / WPF development",
      subtitle2: "Here's the detailed list of our skills",

    },
  },

  message: {
    confirm: 'Confirm',
    error: 'Error',
    failed: 'Failed',
    tip: 'Tip',
    notAvailableYet: 'Not available yet',
    saved: 'Saved',
    success: 'Success',
    welcome: 'Welcome',
  },

  snackbar: {
    saved: 'Saved',
    success: 'Success',
    failed: 'Failed',
  },

}
